import { render, staticRenderFns } from "./download-app-card.vue?vue&type=template&id=767f4aec"
import script from "./download-app-card.vue?vue&type=script&lang=js"
export * from "./download-app-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports